import { render, staticRenderFns } from "./BrandStore.vue?vue&type=template&id=79da884c&"
import script from "./BrandStore.vue?vue&type=script&lang=js&"
export * from "./BrandStore.vue?vue&type=script&lang=js&"
import style0 from "./BrandStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79da884c')) {
      api.createRecord('79da884c', component.options)
    } else {
      api.reload('79da884c', component.options)
    }
    module.hot.accept("./BrandStore.vue?vue&type=template&id=79da884c&", function () {
      api.rerender('79da884c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/BrandStore.vue"
export default component.exports